import { ProfilRequestIcon } from "@images/svgIcons/profilRequestIcon"
import { word } from "@modules/core/utils/i18n"
import { useProgramSASRequests } from "@modules/programs/hooks/usePrograms"
import { ProgramInfinite } from "@modules/programs/programInfiniteTypes"
import { ProgramOnOff } from "@modules/programs/programOnOffTypes"
import { HUText } from "@modules/ui/components/huText"
import dayjs from "dayjs"
import { Badge } from "primereact/badge"
import styled from "styled-components"

type ProgramSasPendingSubscribersProps = {
  program: ProgramInfinite | ProgramOnOff
  displaySASRequestToAcceptView: () => void
}

export const ProgramInfoSasPendingSubscribers: React.FC<ProgramSasPendingSubscribersProps> = ({
  program,
  displaySASRequestToAcceptView,
}) => {
  const { result: sasRequests } = useProgramSASRequests({
    programId: program.id,
    programType: program._programType,
    originDateRequest: dayjs().toDate(),
  })

  if (sasRequests.length === 0) {
    return null
  }

  return (
    <div
      className="flex align-items-center h-2rem justify-content-between cursor-pointer"
      style={{ marginBottom: 20 }}
      onClick={displaySASRequestToAcceptView}
    >
      <div className="flex align-items-center">
        <ProfilRequestIcon color={"black"} />
        <div className="flex flex-column ml-2">
          <HUText fontStyle="TS" className="mb-1">
            {word("program.sas.list.header.title")}
          </HUText>
          <HUText fontStyle="BS">{word("program.sas.list.title", { count: sasRequests.length })}</HUText>
        </div>
      </div>
      <div className="mr-4 flex align-items-center">
        <BadgeContainer>
          <Badge severity="danger" className="mr-2" size="normal"></Badge>
        </BadgeContainer>
        <i className={"pi pi-angle-right"} style={{ fontSize: "1.2rem" }} />
      </div>
    </div>
  )
}

const BadgeContainer = styled.div`
  .p-badge {
    width: 0.6rem;
    min-width: 0.6rem;
    height: 0.6rem;
  }
`
